<template>
  <div class="custom-checkbox">
    <input
      type="checkbox"
      v-bind:name="name"
      v-bind:class="className"
      v-bind:id="id"
      v-bind:required="required"
      v-on:change="updateInput"
    />
    <label class="fs-small font-weight-bold" v-bind:for="id">{{ label }}</label>
  </div>
</template>
<script>
export default {
  name: "CheckboxCustom",

  props: {
    name: {
      type: String,
      required: false,
    },
    className: {
      type: String,
      required: false,
    },
    id: {
      type: String,
      required: false,
    },
    value: {
      type: Boolean,
      required: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    checked: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    inverted: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    updateInput: function (event) {
      let isChecked= event.target.checked;
      this.$emit("onChange", isChecked);
    },
  },
};
</script>

<style lang="scss">

.custom-checkbox {
  // easy inline labels
  display: flex;
  padding: 5px;
  margin: 5px auto;

  input[type="checkbox"],
  input[type="radio"],
  label {
    // dont highlight text when double clicking
    user-select: none;
  }
  input[type="checkbox"],
  input[type="radio"] {
    position: relative;
    border: 2px solid #7c4dff;
    margin: 0 0.2em 0 0;
    padding: 0;
    margin-left: 10px;
    text-align: center;
    width: 1.3rem;
    height: 1.3rem;
    background: #fff;
    -webkit-appearance: none;
    -webkit-border-radius: 0;
    border-radius: 0;
    color: rgba(#fff, 0);
    transition: all 0.2s ease;
    // Better Font Rendering
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    &:before {
      // checkmark
      content: "✔";
    }
    &:focus {
      outline: 0;
      border: 2px solid darken(#7c4dff, 5%);
    }
    &:active {
      outline: none;
    }
    &:hover {
      outline: none;
    }
    &:checked {
      background: #7c4dff;
      // the color is what hides the checkmark
      color: rgba(white, 1);
    }
  }
  // an `inverted` class is there for making simple alternative styles
  &.inverted {
    input[type="checkbox"],
    input[type="radio"] {
      border: 2px solid #7c4dff;
      &:focus {
        border: 2px solid darken(#7c4dff, 5%);
      }
      &:checked {
        background: #7c4dff;
      }
    }
  }
}
</style>
